// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__QxeZC","calendarButtons":"ClockData_calendarButtons__1AFer"};